import { LanguageSwitcher } from "./LanguageSwitcher";

export function Header() {
  return (
    <header className="container py-4 flex justify-end">
      <LanguageSwitcher />
    </header>
  );
}
